import { z } from "zod";
import {
  telemetryConnectionStatusSchema,
  highMobilityConnectionPlanSchema,
  telemetryDataProviderSchema,
} from "../_shared";

export const getAnalyticsVehiclesOfACompanyResponseSchema = z.array(
  z.object({
    uuid: z.uuid(),
    registrationNumber: z.string().nullable(),
    identifier: z.string().nullable(),
    reference: z.string().nullable(),
    deliveryDate: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
    vehicleType: z.enum(["SHARED", "PERSONAL", "OUT_OF_FLEET"]),
    status: z.enum(["ORDERED", "IN_CIRCULATION", "DEACTIVATED"]),
    rule: z.string().nullable(),
    driverUuid: z.string().nullable(),
    critAir: z.number().nullable(),
    energyClass: z.string().nullable(),
    brand: z.string().nullable(),
    model: z.string().nullable(),
    energy: z.string().nullable(),
    latestMileageDate: z.string().nullable(),
    latestMileage: z.number().nullable(),
    driverName: z.string().nullable(),
    driverPhone: z.string().nullable(),
    averagePricePerLiter: z.number().nullable(),
    averageConsumption: z.number().nullable(),
    averageCarbonEmissionPerKm: z.number().nullable(),
    analyticCode: z.string().nullable(),
    noteTaking: z.string().nullable(),
    lastLatitude: z.number().nullable(),
    lastLongitude: z.number().nullable(),
    lastPositionDate: z.string().nullable(),
    connectionStatus: telemetryConnectionStatusSchema.nullable(),
    dataProvider: telemetryDataProviderSchema.nullable(),
    geolocationError: z.string().nullable(),
    hasTelemetry: z.boolean().nullable(),
    deviceId: z.string().nullable().optional(),
    isEligible: z.boolean().nullable(),
    lastTripsDate: z.iso.datetime().nullable(),
    vin: z.string().nullable(),
    department: z.string().nullable().optional(),
    connectionRevokedAt: z.iso.datetime().nullable(),
    requestedConnectionAt: z.iso.datetime().nullable(),
    connectionPlan: highMobilityConnectionPlanSchema.nullable(),
    deviceInstalledAt: z.iso.datetime().nullable(),
    deviceLastActivityDate: z.iso.datetime().nullable(),
  }),
);

export type GetAnalyticsVehiclesOfACompanyResponse = z.infer<
  typeof getAnalyticsVehiclesOfACompanyResponseSchema
>;
